import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { useField } from 'react-final-form';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import CTAButton from '../../../../../CTAButton/CTAButton';

import {
  TXTCLI_Cancel_Pending_Cashouts,
  TXTWCL_Cancel_pending_withdrawal
} from './SubmitButton.messages.json';
import { button } from './SubmitButton.scss';

interface Props {
  fieldName: string;
}

const SubmitButton: React.FC<Props> = ({ fieldName }) => {
  const {
    input: { value, onChange }
  } = useField(fieldName);

  const {
    data: { pendingCashouts }
  } = useWizardContext();

  const singleTransaction = pendingCashouts.length === 1;

  useEffect(() => {
    if (singleTransaction && isEmpty(value)) {
      onChange([pendingCashouts[0].transactionId]);
    }
  }, [onChange, pendingCashouts, singleTransaction, value]);

  return (
    <CTAButton
      className={button}
      translation={
        singleTransaction ? TXTWCL_Cancel_pending_withdrawal : TXTCLI_Cancel_Pending_Cashouts
      }
      disabled={isEmpty(value)}
    />
  );
};
export default SubmitButton;
